import { createSlice } from "@reduxjs/toolkit";

export const inicialGrupoEspecificacoes = {
  params: {
    limit: 15,
    page: 1,
  },
  modal: {
    show: false,
    showPortaria: false,
  },
};

const initialState = () => {
  return inicialGrupoEspecificacoes;
};

export const CasosSlice = createSlice({
  name: "grupoEspecificacoes",
  initialState,
  reducers: {
    handleParams: (state, { payload }) => {
      const field = payload?.field;
      state.params[field] = payload?.value;
      return state;
    },
    handleSetSearch: (state, { payload }) => {
      const field = payload?.field;
      if (payload?.isDelete) {
        delete state.params[payload?.field];
      } else {
        state.params[field] = payload?.value;
      }
      return state;
    },
    handleModal: (state, { payload }) => {
      const field = payload?.field;
      state.modal[field] = payload?.value;
      return state;
    },
  },
});

export const { handleParams, handleSetSearch, handleModal } =
  CasosSlice.actions;

export default CasosSlice.reducer;
